import React from 'react'
import styled, { css } from 'styled-components'
import ImageData from '../../../types/ImageData'
import { useSelector } from '../../store/hooks'
import { ANIMATION_SCALE, breakpoint, device } from '../../style'
import Icon from '../Icon'
import Teaser from '../Teaser'

const SliderArrowButton = styled.button<{
  position: 'left' | 'right'
}>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35px;
  user-style: none;
  border: none;
  border-radius: 0;
  background: none;
  pointer-events: all;
  z-index: 5;

  ${({ position }) =>
    position === 'left'
      ? css`
          left: 0;
        `
      : css`
          right: 0;
        `}

  @media ${device.laptop} {
    width: 65px;
  }

  > div {
    width: 280px;
    text-align: left;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    visibility: hidden;
    opacity: 0;
    transition-property: visibility, opacity, transform;
    will-change: visibility, opacity, transform;
    transition-duration: ${0.3 * ANIMATION_SCALE}s;
    transition-easing: ease-in-out;

    ${({ position }) =>
      position === 'left'
        ? css`
            transform: translate(-30%, -50%);
            left: 60px;
          `
        : css`
            transform: translate(30%, -50%);
            right: 60px;
          `}
  }

  &:hover {
    > div {
      visibility: visible;
      opacity: 1;
      transform: translate(0, -50%);
    }
  }
`

const SliderArrowButtonIcon = styled(Icon)`
  color: #fff;
  font-size: 25px;
`

const SliderArrowTeaser = styled(Teaser)`
  width: 100%;
  margin-bottom: 0;
  a {
    box-shadow: none;
  }

  .teaser__content {
    padding: 0 20px;

    h3 {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 52px;
      font-size: 16px;
      text-transform: none;
    }
  }
`

export type SliderArrowsBigProps = {
  next?: {
    backgroundImage?: ImageData
    title?: string
  }
  previous?: {
    backgroundImage?: ImageData
    title?: string
  }
  onPrevious?: () => unknown
  onNext?: () => unknown
}

const SliderArrowsBig: React.FC<SliderArrowsBigProps> = ({ previous, next, onPrevious, onNext }) => {
  const screenWidth = useSelector((state) => state.ui.screenSize.width)

  return (
    <>
      <SliderArrowButton position="left" onClick={onPrevious}>
        {screenWidth >= breakpoint.laptop && (
          <div>
            <SliderArrowTeaser image={previous?.backgroundImage} title={previous?.title} />
          </div>
        )}
        <SliderArrowButtonIcon name="chevron-left" />
      </SliderArrowButton>
      <SliderArrowButton position="right" onClick={onNext}>
        {screenWidth >= breakpoint.laptop && (
          <div>
            <SliderArrowTeaser image={next?.backgroundImage} title={next?.title} />
          </div>
        )}
        <SliderArrowButtonIcon name="chevron-right" />
      </SliderArrowButton>
    </>
  )
}

export default SliderArrowsBig
